import { render, staticRenderFns } from "./EspaceClientStats.vue?vue&type=template&id=785f9b1d&"
import script from "./EspaceClientStats.vue?vue&type=script&lang=js&"
export * from "./EspaceClientStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports